import type { dashboardCanvasRendererProps } from '@/components/dashboard/DashboardCanvas';
import { DashboardPerformanceChart } from '../../dashboard/components/DashboardPerformanceChart';
import type { PublisherDashboardRuntime } from './widgetRuntime';
import { PublisherDashboardWidgetType, type PublisherDashboardWidget } from './widgetModel';

export function PublisherPerformanceRenderer({
  widget,
  runtime,
}: dashboardCanvasRendererProps<PublisherDashboardWidget, PublisherDashboardRuntime>) {
  if (widget.type !== PublisherDashboardWidgetType.PerformanceChart) return null;
  return (
    <DashboardPerformanceChart
      overview={runtime.overview.data}
      metrics={widget.metrics}
      range={runtime.range}
      loading={runtime.overview.isLoading}
      error={runtime.overview.isError}
      actions={[]}
    />
  );
}
